import { type ReactElement } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { MetaAssetsSelect } from '@/components/connectors/meta-assets-select';
import { ROUTES } from '@/constants/routes';
import { loadNamespaces } from '@/lib/i18n/i18n';

const searchSchema = z.object({
  pending: z.string().min(1),
  from: z.string().optional(),
});

export const Route = createFileRoute('/_authenticated/connect-meta-assets')({
  loader: () => loadNamespaces('settings'),
  validateSearch: searchSchema,
  staticData: { hideAppShell: true, title: 'route.connect_meta_assets.title' },
  component: ConnectMetaAssetsPage,
});

function ConnectMetaAssetsPage(): ReactElement {
  const { pending, from } = Route.useSearch();
  return (
    <div className="bg-bg-page flex min-h-svh items-center justify-center p-6">
      <MetaAssetsSelect
        pending={pending}
        redirectTo={from ?? ROUTES.CONNECTORS}
        className="w-full max-w-md"
      />
    </div>
  );
}
